// src/modules/app-views/invoices/components/InvoicesToolbarLeft.jsx

// *******************************************************************************
// IMPORTS
// *******************************************************************************

import { useListContext } from 'components/core/ListProvider';
import FilterButton from 'layouts/Pages/PageHeader/FilterButton';

import InvoicesFilterPopover from './InvoicesFilterPopover';
import InvoicesGlobalSearch from './InvoicesGlobalSearch';
import './InvoicesToolbarLeft.less';

// *******************************************************************************
// COMPONENT
// *******************************************************************************
const InvoicesToolbarLeft = () => {
  const { query } = useListContext() || {};

  const hasPopoverFilter = !!(
    query?.filter?.documentType?.length ||
    query?.filter?.status?.length ||
    query?.drawer?.dateRange?.length
  );

  return (
    <div className="invoices-toolbar-left">
      <InvoicesGlobalSearch className="toolbar-search" />
      <FilterButton
        actions={['filter']}
        popoverContent={<InvoicesFilterPopover />}
        hasActiveFilter={hasPopoverFilter}
      />
    </div>
  );
};

// *******************************************************************************
// EXPORT
// *******************************************************************************
export default InvoicesToolbarLeft;
